import { render } from "./App.vue?vue&type=template&id=c7efeb4a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=c7efeb4a&lang=scss"

import exportComponent from "/Users/ebas/Dropbox/ebDev/Workspace/bis/customer-portal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__